import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateGroupGeofence, UpdateGroupGeofence} from "../../types/api/guide/groupGeofence.types";

const pagedQuery = (page: number, pageSize: number, name?: string) => {
    const params: Record<string, string | number> = { page, pageSize };
    if (name != null && name.trim() !== "") params.name = name.trim();
    return { params };
};

export const groupGeofenceService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.groupGeofence.getAll),

    getPaged: (page: number, pageSize: number, name?: string) =>
        apiCall.get(apiUrls.guide.groupGeofence.getPaged, pagedQuery(page, pageSize, name)),

    create: (company: CreateGroupGeofence) =>
        apiCall.post(apiUrls.guide.groupGeofence.create, company),

    update: (id: string, company: UpdateGroupGeofence) =>
        apiCall.put(apiUrls.guide.groupGeofence.update(id), company),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.groupGeofence.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.groupGeofence.getById(id))
}